import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=0aca3210&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutHeader: require('/vercel/path0/components/navigation/CheckoutHeader.vue').default,PageFooter: require('/vercel/path0/components/PageFooter.vue').default})
